import type { ReactNode } from 'react';
import Container from '../container/Container';

type Props = {
	children: ReactNode;
};

const TabContent = ({ children }: Props) => {
	return <Container>{children}</Container>;
};

export default TabContent;
